import { Cart } from '@hiwaldo/sdk/interfaces';
import { useDispatch } from 'react-redux';
import { cartSlice } from '../../../redux';
import { CartFetched } from '@hiwaldo/sdk/interfaces/order/cart-fetched.interface';

export const useGetCartFetchByClientIdEffect = async (cart: Cart) => {
  const dispatch = useDispatch();
  if (!cart?.fetched) {
    const externalGateway =
      process?.env?.NEXT_PUBLIC_EXTERNAL_SERVICE_URL || 'http://localhost:4846';

    const res = await fetch(
      `${externalGateway}/v1/stripe/payment_intents?cartId=${cart.id}`
    );
    const paymentIntentResponse = await res.json();
    if (paymentIntentResponse) {
      if (paymentIntentResponse.success) {
        if (paymentIntentResponse.data.paymentIntent.client_secret != '') {
          const cartFetched: CartFetched = {
            paymentIntentClientSecret:
              paymentIntentResponse.data.paymentIntent.client_secret,
          };
          dispatch(cartSlice.actions.setFetchedClientSecret(cartFetched));
        }
      }
    }
  }
};
